import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function useCategories(env, client) {
  const [loadedCategories, setLoadedCategories] = useState(false);
  const [categories, setCategories] = useState(null);

  useEffect(() => {
    setLoadedCategories(false);
    if (!client) {
      setLoadedCategories(true);
      return () => [];
    }
    let ref = collection(db, "kiosk", env, "client", client, "categories");
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(data);
      setLoadedCategories(true);
    });
    return () => unsub();
  }, [env, client]);
  
  return { loadedCategories, categories };
}